import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { StoreInformation, UserCogIcon, UserIcon, UsersCog, UsersIcon } from '@/icons';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/users')({
  loader: ({ context }) => {
    context.groupLabel = 'userManagement.sidebar.title';
    context.childRoutes = [
      {
        id: 'userManagement.sidebar.menu.rolesPrivileges',
        label: 'Roles & Privileges',
        path: '/users/roles',
        icon: UserCogIcon,
      },
      {
        id: 'userManagement.sidebar.menu.adminStaffs',
        label: 'Admin Staffs',
        path: '/users/admin',
        icon: UserIcon,
      },
      {
        id: 'userManagement.sidebar.menu.storeOwners',
        label: 'Store Owner',
        path: '/users/store-owners',
        icon: StoreInformation,
      },
      {
        id: 'userManagement.sidebar.menu.affiliates',
        label: 'Affiliates',
        path: '/users/affiliates',
        icon: UsersIcon,
      },
      {
        id: 'userManagement.sidebar.menu.customers',
        label: 'Customers',
        path: '/users/customers',
        icon: UsersIcon,
      },
    ];
    return {
      crumb: <CrumbTitle icon={UsersCog} id="userManagement.sidebar.title" />,
    };
  },
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
